module.exports = __webpack_public_path__ + "static/media/simondice.080092a3.png";